import {Controller} from '../Controller';
import {DataSource} from '../../common/decorators/rxdb/DataSource';
import {map, Observable, switchMap} from 'rxjs';
import {RxBigRock} from '../../common/model/db/types/RxBigRock';
import {DataSourceKind} from '../../common/decorators/rxdb/DataSourceKind';
import {RxGroupProperty} from '../../common/model/db/types/RxGroupProperty';
import {RxProperty} from '../../common/model/db/types/RxProperty';
import {Throttled} from '../../common/decorators/methods/Throttled';
import {Bound} from '../../common/decorators/methods/Bound';
import {tAsString} from '../../common/helpers/react/text/tAsString';

export class BigRocksController extends Controller {
    @Bound()
    @Throttled()
    async refreshBigRocks(groupId: number = Number.POSITIVE_INFINITY): Promise<void> {
        await this.getBusyFlag().run(
            () => this.services.bigRocks.getBigRocks(groupId), tAsString('REFRESHING_BIG_ROCKS'));
    }

    @DataSource(DataSourceKind.PARAMETRIZED)
    getBigRocks(): Observable<RxBigRock[]> {
        return this.db.big_rocks.$.pipe(
            map((rows: RxBigRock[]) => {
                    return rows.sort((a, b) => {
                            return a.name > b.name
                                ? 1
                                : b.name > a.name
                                    ? -1
                                    : 0;
                        }
                    );
                }
            )
        );
    }

    @DataSource(DataSourceKind.PARAMETRIZED)
    getBigRockProperties(bigRockId: string): Observable<RxProperty[]> {
        return this.db.big_rocks.getById$(bigRockId).pipe(
            switchMap(bigRock => {
                if (bigRock) {
                    return this.db.properties.$.pipe(
                        map(rows => {
                            return rows.filter(it => {
                                return bigRock.property_ids?.includes(it.id)
                            })
                        })
                    ).sort((a, b) => {
                        if (!a.name || !b.name) {
                            return 0;
                        }

                        return a.name > b.name
                            ? 1
                            : b.name > a.name
                                ? -1
                                : 0;
                    })
                } else {
                    return []
                }
            })
        );
    }

    @DataSource(DataSourceKind.PARAMETRIZED)
    getBigRockPropertiesSet(bigRockId: string): Observable<RxGroupProperty[]> {
        return this.db.big_rocks.getById$(bigRockId).pipe(
            switchMap(bigRock => this.db.group_properties.$.pipe(
                    map(rows => {
                        return rows.filter(it => {
                            return bigRock?.property_ids?.includes(it.property)
                        })
                    })
                )
            )
        )
    }
}